import { render, staticRenderFns } from "./historyOrderListForAdmin.vue?vue&type=template&id=4b563332&scoped=true&"
import script from "./historyOrderListForAdmin.vue?vue&type=script&lang=js&"
export * from "./historyOrderListForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./historyOrderListForAdmin.vue?vue&type=style&index=0&id=4b563332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b563332",
  null
  
)

export default component.exports